import { callAPI, isset } from "../../helpers/kiosk-helpers";

export class ApiModel {
    #fillable;

    constructor(fillable = [], properties = {}) {
        this.#fillable = fillable;

        fillable.forEach((column) => {
            if(isset(properties[column]))
            {
                this[column] = properties[column];
            }
        });
    }

    static callAPI(endpoint, fd, method) {
        return new window.Promise((resolve, reject) => {
            callAPI(endpoint, fd, method)
                .then(response => {
                    let result = this.parseResponse(response);

                    if(result['success'])
                    {
                        resolve(result['rows']);
                    }
                    else
                    {
                        reject(result['errors'] ?? [ 'Unknown error' ]);
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static parseResponse(response) {
        let result = {
            errors: [],
        }

        if(!isset(response['data']))
        {
            result['success'] = false;
            return result;
        }

        if(!isset(response['data']['success']) || !isset(response['data']['ds']))
        {
            result['success'] = false;
            return result;
        }

        if(parseInt(response['data']['success']) !== 1 || !isset(response['data']['ds']['rows']))
        {
            result['success'] = false;
            return result;
        }

        result['success'] = true;
        result['rows'] = response['data']['ds']['rows'];

        return result;
    }

}
